<template>
    <v-dialog v-model="getModalVisualizarTransferenciaEstoque" persistent max-width="720px" transition="dialog-transition">
        <v-card outlined>
            <v-card-title>
                Transferência de Estoque Nº {{getTransferenciaEstoque.id}}
            </v-card-title>
            <v-card-text>
                <v-simple-table dense>
                    <template v-slot:default>
                        <tbody>
                            <tr>
                                <td>Estoque de Origem</td>
                                <td>{{getTransferenciaEstoque.estoque_origem.nome}}</td>
                            </tr>
                            <tr>
                                <td>Estoque de Destino</td>
                                <td>{{getTransferenciaEstoque.estoque_destino.nome}}</td>
                            </tr>
                            <tr>
                                <td>Data e Hora</td>
                                <td>{{$helper.formatDate(getTransferenciaEstoque.data)}} - {{getTransferenciaEstoque.hora}}</td>
                            </tr>
                            <tr>
                                <td>Funcionário</td>
                                <td>{{getTransferenciaEstoque.funcionario.nome}}</td>
                            </tr>
                            <tr>
                                <td>Observação</td>
                                <td>{{getTransferenciaEstoque.observacao}}</td>
                            </tr>
                           
                        </tbody>
                    </template>
                </v-simple-table>

                <v-divider></v-divider>
                <v-card-title>
                    Produtos Transferidos
                </v-card-title>

                <v-simple-table dense>
                    <template v-slot:default>
                        <thead>
                            <tr>
                                <th style="background: #e2e2e2;"> CÓDIGO </th>
                                <th style="background: #e2e2e2;"> PRODUTO </th>
                                <th style="background: #e2e2e2;"> QUANTIDADE </th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-show="produto.tipo==='SAIDA'" v-for="produto in getTransferenciaEstoque.movimentacoes_produtos" :key="produto.id">
                                <td>{{ produto.id }}</td>
                                <td>{{ produto.descricao }}</td>
                                <td>{{ produto.quantidade }}</td>
                            </tr>
                           
                        </tbody>
                    </template>
                </v-simple-table>
            </v-card-text>
            <v-card-actions>
                <v-btn color="default" @click="setModalVisualizarTransferenciaEstoque(false)" :loading="$store.getters.getOverlay" outlined>Voltar</v-btn>
                <v-spacer></v-spacer>
                <v-btn color="primary" @click="imprimirComprovanteTransferenciaEstoque(getTransferenciaEstoque.id)" :loading="$store.getters.getOverlay" outlined>Imprimir</v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>
<script>
    import { mapGetters, mapActions } from 'vuex'

    export default {
        computed: {
            ...mapGetters([
                'getModalVisualizarTransferenciaEstoque',
                'getTransferenciaEstoque'
            ])
        },
        methods: {
            ...mapActions([
                'setModalVisualizarTransferenciaEstoque',
                'imprimirComprovanteTransferenciaEstoque'
            ]),
        }
    }
</script>